module.exports = __webpack_public_path__ + "static/img/search.c9ef80e4.svg";